<template>
  <div class="modal rounded">
    <vue-plyr ref="plyr">
      <video poster="poster.png" :src="content.src">
        <source :src="content.src" type="video/mp4" size="720">
        <!-- <source src="video-1080p.mp4" type="video/mp4" size="1080"> -->
        <!-- <track kind="captions" label="English" srclang="en" src="captions-en.vtt" default> -->
      </video>
    </vue-plyr>
  </div>
</template>

<script>
import { modalMixin } from '@/mixins/modalMixin.js'
export default {
  name: 'video-modal',
  mixins: [modalMixin],
  mounted() {
    this.$emit('setPlayer', this.$refs.plyr.player);
  }
}
</script>

<style lang="scss" scoped>
.modal {
  max-height: 85vh !important;
}
</style>